import * as React from "react";
import { useState } from "react";
import Grid from "@mui/material/Grid2";
import { FormInputText } from "../../components/common/FormInputText";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { deliveryAddressSchema } from "../../utilities/schema";
import { Box, Button, Paper, Stack, styled, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import AddressCard from "./AddressCard";
import useApiQuery from "../../hooks/useApiQuery";
import {
  getAddressListWithDeliveryCharge,
  getPrimaryAddress,
  updateCartQuantity,
  updatePrimaryAddress,
} from "../../utilities/service";
import { useAuth } from "../../hooks/AuthContext";
import useApiMutation from "../../hooks/useApiMutation";
import { toast } from "react-toastify";

const AddressTypeButton = styled(Button)(({ theme, selected }) => ({
  borderRadius: "30px",
  padding: "10px",
  width: "80px",
  height: "32px",
  borderColor: selected ? theme.palette.primary.main : "var(--neutral-300)",
  backgroundColor: selected ? "var(--primary-red-100)" : "transparent",
  color: selected ? theme.palette.primary.main : "var(--neutral-800)",
}));
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  ...theme.applyStyles("dark", {
    backgroundColor: "#1A2027",
  }),
}));
export default function AddressList() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const methods = useForm({
    resolver: yupResolver(deliveryAddressSchema),
  });
  const {
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = methods;

  const {
    data: addressList,
    error: addressError,
    isLoading: addressLoader,
    refetch,
  } = useApiQuery({
    queryKey: [
      "getAddressListWithDeliveryCharge",
      user?.customer_id,
      user?.region_id,
    ],
    queryFn: () =>
      getAddressListWithDeliveryCharge(user?.customer_id, user?.region_id),
  });
  const {
    data: primaryAddress,
    error: primaryAddressError,
    isLoading: primaryAddressLoader,
    refetch: primaryAddressRefetch,
  } = useApiQuery({
    queryKey: ["getPrimaryAddress", user?.customer_id],
    queryFn: () => getPrimaryAddress(user?.customer_id),
  });
  const { mutate } = useApiMutation({
    mutationFn: (param) => updatePrimaryAddress(param),
    options: {
      onSuccess: (data) => {
        console.log(data);
        if (!data?.error) {
          toast.success(data?.message);
          refetch();
          primaryAddressRefetch();
        } else {
          toast.error(data?.message);
        }
      },
      onError: (error) => {
        toast.error(error?.message);
        console.error("Error in update cart qty:", error);
      },
    },
  });
  const handlePrimaryAddress = async (address) => {
    if (address && user?.customer_id) {
      const param = {
        customerId: user?.customer_id,
        addressId: address?.customer_address_id,
      };
      mutate(param);
      // processAddressAndDeliveryDetails(address);
    }
  };

  return (
    <Grid container spacing={2}>
      {addressList?.data?.map((item, index) => (
        <Grid size={6} key={index}>
          <AddressCard
            item={item}
            selected={
              item?.customer_address_id ==
              primaryAddress?.data?.[0]?.customer_address_id
            }
            onSelect={handlePrimaryAddress}
          />
        </Grid>
      ))}
      <Grid size={12} sx={{ mt: 2 }}>
        <Button
          onClick={() => navigate("/pre-checkout/add-address")}
          variant="outlined"
          sx={{
            py: 1.5,
            fontSize: "16px",
            width: "100%",
            border: "1px solid var(--primary-red-base)",
          }}
        >
          +Add new address
        </Button>
      </Grid>
    </Grid>
  );
}
